import * as React from "react";
import {
  Spinner,
  Badge,
  Box,
  Button,
  Container,
  ContentLayout,
  CopyToClipboard,
  ExpandableSection,
  Flashbar,
  Grid,
  Header,
  LiveRegion,
  ProgressBar,
  SpaceBetween,
  Table,
  Tabs,
  TextContent,
} from "@cloudscape-design/components";
import KeyValuePairs from "@cloudscape-design/components/key-value-pairs";
import axios from "axios";
import serverEndpoint from "../../config";
import { Link, useSearchParams } from "react-router-dom";
import { LoadingBar } from "@cloudscape-design/chat-components";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";
import moment from "moment";
// import { Document, pdfjs, Page } from 'react-pdf'
// import { EmbedPDF } from '@simplepdf/react-embed-pdf';
import { Viewer } from "@react-pdf-viewer/core";

// Import the styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import { Worker } from "@react-pdf-viewer/core";
Array.prototype.move = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.mjs',
//   import.meta.url,
// ).toString();

function ManualLandingPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const [policyData, setPolicyData] = React.useState({});
  const [policyDataValues, setPolicyDataValues] = React.useState([]);
  const [isPolicyDataLoaded, setIsPolicyDataLoaded] = React.useState(false);

  const toggleLang = () => {
    console.log(i18n.language);
    if (i18n.language === "ar") {
      i18n.changeLanguage("en");
      populateValues();
    } else if (i18n.language === "en") {
      i18n.changeLanguage("ar");
      populateValues();
    }
  };

  const populateValues = (policyDataPassed = null) => {
    if (policyDataPassed === null) {
      policyDataPassed = policyData.data;
    }

    if (policyDataPassed === null) {
      return false;
    }

    let items = [
      {
        label: `${t("Policy Number")}`,
        value: (
          // <CopyToClipboard
          //   copyButtonAriaLabel="Copy Policy Number"
          //   copyErrorText="Policy Number failed to copy"
          //   copySuccessText="Policy Number copied"
          //   textToCopy={`${policyDataPassed.policy_number}`}
          //   variant="inline"
          // />
          <TextContent>
            <p>{policyDataPassed.policy_number}</p>
          </TextContent>
        ),
      },
      {
        label: `${t("Insured Name")}`,
        value: (
          <TextContent>
            <p>{policyDataPassed.assured_name}</p>
          </TextContent>
        ),
      },
      {
        label: `${t("Status")}`,
        value:
          policyDataPassed.on_hold ? (
            <Badge color="severity-medium">{t("Policy Is on hold")}</Badge>
          ) : policyDataPassed.sts === "C" ? (
            <Badge color="severity-critical">{t("Cancelled")}</Badge>
          ) : (
            <Badge color="green">{t("Active")}</Badge>
          ),
      },
      {
        label: `${t("Valid From")}`,
        value: (
          <TextContent>
            <p>{policyDataPassed.valid_from}</p>
          </TextContent>
        ),
      },
      {
        label: `${t("Valid Till")}`,
        value: (
          <TextContent>
            <p>{policyDataPassed.valid_till}</p>
          </TextContent>
        ),
      },

      {
        label: `${t("Tenure")}`,
        value: (
          <TextContent>
            <p>
              {policyDataPassed.days_between}{" "}
              {policyDataPassed.days_between === 1 ? t("day") : t("days")}
            </p>
          </TextContent>
        ),
      },
    ];

    // if (i18n.language === "ar") {

    //   items.move(0, 2)
    //   items.move(1, 0)
    //   // items.move(1, 0)

    // }

    if (policyDataPassed.sts !== "C") {
      items.push({
        label: `${t("Tenure Status")}`,
        id: "tenure_status",
        value:
          policyDataPassed.days_from > 0 ? (
            <Badge>{t("Yet to Start")}</Badge>
          ) : policyDataPassed.active ? (
            <ProgressBar
              value={policyDataPassed.days_percentage}
              additionalInfo={`${Math.abs(policyDataPassed.days_left)} ${
                policyDataPassed.days_left === 1 ? t("day") : t("days")
              } ${policyDataPassed.days_left < 0 ? t("left") : t("ago")}`}
              ariaLabelledby="tenure_status"
            />
          ) : (
            <Badge color="red">{t("Expired")}</Badge>
          ),
      });

      items.push({
        label: `${t("Cover")}`,
        value: (
          <TextContent>
            <p>{policyDataPassed.product_description}</p>
          </TextContent>
        ),
      });

      if (policyDataPassed.broker) {
        items.push({
          label: `${t("Broker")}`,
          value: (
            <TextContent>
              <SpaceBetween size="xxxs">
                <p>{policyDataPassed.broker}</p>
                {/* {parseFloat(policyDataPassed.broker_share) ? (<SpaceBetween direction="horizontal" size='xxxs'><Badge>KD {parseFloat(policyDataPassed.broker_share).toFixed(3)}</Badge><Badge color="green">{policyDataPassed.BROKER_PREC} %</Badge></SpaceBetween>) : '' } */}
              </SpaceBetween>
            </TextContent>
          ),
        });
      } else {
        items.push({
          label: `${t("Broker")}`,
          value: <Badge color="green">Direct</Badge>,
        });
      }

      // if (i18n.language === "ar") {

      //   items.move(5, 3)
      //   items.move(5, 4)
      // }
    } else {
      items.push({
        label: ` `,
        id: " ",
        value: "",
      });

      // if (i18n.language === "ar") {

      //   items.move(5, 3)
      //   items.move(5, 4)
      // }
    }

    setPolicyDataValues(items);
  };

  const [isRisksDataLoaded, setIsRisksDataLoaded] = React.useState(false);
  const [isRisksData, setIsRisksData] = React.useState([]);

  const getRisks = () => {
    axios
      .get(
        `${serverEndpoint}/api/risks?data=${
          searchParams.get("data").split("_")[0]
        }`
      )
      .then(
        (response) => {
          setIsRisksDataLoaded(true);
          response = response.data;
          if (response.operation === true) {
            setIsRisksData(response.data);
          }
        },
        (error) => {
          console.error(error);
          try {
            setIsRisksDataLoaded(true);
            setIsRisksData([]);
          } catch {
            setIsRisksData([]);
          }
        }
      );
  };

  const [isPremiumEndorsementLoaded, setIsPremiumEndorsementLoaded] =
    React.useState(false);
  const [premiumEndorsementData, setPremiumEndorsementData] = React.useState(
    []
  );

  const getPremiumEndorsement = () => {
    axios
      .get(
        `${serverEndpoint}/api/premium_endorsement?data=${
          searchParams.get("data").split("_")[0]
        }`
      )
      .then(
        (response) => {
          setIsPremiumEndorsementLoaded(true);
          response = response.data;
          if (response.operation === true) {
            setPremiumEndorsementData(response.data);
          }
        },
        (error) => {
          console.error(error);
          try {
            setIsPremiumEndorsementLoaded(true);
            setPremiumEndorsementData([]);
          } catch {
            setPremiumEndorsementData([]);
          }
        }
      );
  };

  const [isConditionsLoaded, setIsConditionsLoaded] = React.useState(false);
  const [conditionsData, setConditionsData] = React.useState([]);

  const getConditions = () => {
    axios
      .get(
        `${serverEndpoint}/api/conditions?data=${
          searchParams.get("data").split("_")[0]
        }`
      )
      .then(
        (response) => {
          setIsConditionsLoaded(true);
          response = response.data;
          if (response.operation === true) {
            setConditionsData(response.data);
          }
        },
        (error) => {
          try {
            setIsConditionsLoaded(true);
            setConditionsData([]);
          } catch {
            setConditionsData([]);
          }
        }
      );
  };

  const [tabsList, setTabsList] = React.useState([]);

  React.useEffect(() => {
    setIsPolicyDataLoaded(false);
    setPolicyData([]);
    setPolicyDataValues([]);
    axios
      .get(
        `${serverEndpoint}/api/analyze?data=${
          searchParams.get("data").split("_")[0]
        }&idx=${searchParams.get("data").split("_")[1] ?? "0"}&od=1`
      )
      .then(
        (response) => {
          setIsPolicyDataLoaded(true);
          response = response.data;
          if (response.operation === true) {
            setPolicyData(response);
            populateValues(response.data);
            // getRisks();
            if (response.data.policy_number.startsWith("5")) {
              getConditions();
            } else {
              getRisks();
              setActiveTabId("risks");
            }

            // if (response.data.policy_number.startsWith("500")) {
            //   setTabsList((p) => [
            //     ...p,
            //     {
            //       label: "Conditions",
            //       id: "conditions",
            //       content: (
            //         <Table
            //           columnDefinitions={[
            //             {
            //               id: "sr_no",
            //               header: "Serial No.",
            //               cell: (item) => item.sr_no || "-",
            //               sortingField: "sr_no",
            //             },
            //             {
            //               id: "description",
            //               header: "Description",
            //               cell: (item) => item.description || "-",
            //             },
            //           ]}
            //           enableKeyboardNavigation
            //           items={conditionsData}
            //           loadingText="Loading conditions"
            //           loading={!isConditionsLoaded}
            //           sortingDisabled
            //           empty={
            //             <Box
            //               margin={{ vertical: "xs" }}
            //               textAlign="center"
            //               color="inherit"
            //             >
            //               <SpaceBetween size="m">
            //                 <b>No conditions</b>
            //               </SpaceBetween>
            //             </Box>
            //           }
            //         />
            //       ),
            //     },
            //   ]);

            //   setTabsList((p) => [
            //     ...p,
            //     {
            //       label: "Risks",
            //       id: "risks",
            //       content: (
            //         <Table
            //           columnDefinitions={[
            //             {
            //               id: "id",
            //               header: "ID",
            //               cell: (item) => item.id || "-",
            //               sortingField: "id",
            //               isRowHeader: true,
            //             },
            //             {
            //               id: "added_on",
            //               header: "Added On",
            //               cell: (item) =>
            //                 moment(new Date(item.added_on)).isValid() ? (
            //                   <Badge>
            //                     {moment(new Date(item.added_on)).format(
            //                       "DD-MMM-YYYY"
            //                     )}
            //                   </Badge>
            //                 ) : (
            //                   "-" || "-"
            //                 ),
            //               sortingField: "added_on",
            //             },
            //             {
            //               id: "deleted_on",
            //               header: "Deleted On",
            //               cell: (item) =>
            //                 moment(new Date(item.deleted_on)).isValid() ? (
            //                   <Badge color="red">
            //                     {moment(new Date(item.deleted_on)).format(
            //                       "DD-MMM-YYYY"
            //                     )}
            //                   </Badge>
            //                 ) : (
            //                   "-" || "-"
            //                 ),
            //               sortingField: "deleted_on",
            //             },
            //             {
            //               id: "effective_start",
            //               header: "Effective Start",
            //               cell: (item) =>
            //                 moment(new Date(item.effective_start)).isValid() ? (
            //                   <Badge color="green">
            //                     {moment(new Date(item.effective_start)).format(
            //                       "DD-MMM-YYYY"
            //                     )}
            //                   </Badge>
            //                 ) : (
            //                   "-" || "-"
            //                 ),
            //               sortingField: "effective_start",
            //             },
            //             {
            //               id: "effective_end",
            //               header: "Effective End",
            //               cell: (item) =>
            //                 moment(new Date(item.effective_end)).isValid() ? (
            //                   <Badge
            //                     color={
            //                       moment(new Date(item.deleted_on)).isValid()
            //                         ? "red"
            //                         : "green"
            //                     }
            //                   >
            //                     {moment(new Date(item.effective_end)).format(
            //                       "DD-MMM-YYYY"
            //                     )}
            //                   </Badge>
            //                 ) : (
            //                   "-" || "-"
            //                 ),
            //               sortingField: "effective_end",
            //             },
            //             {
            //               id: "registration_no",
            //               header: "Registration No.",
            //               cell: (item) => item.registration_no || "-",
            //             },
            //             {
            //               id: "chassis_no",
            //               header: "Chassis No.",
            //               cell: (item) => item.chassis_no || "-",
            //             },
            //             {
            //               id: "vehicle_make",
            //               header: "Make",
            //               cell: (item) => item.vehicle_make || "-",
            //             },
            //             {
            //               id: "sum_insured",
            //               header: "Sum Insured",
            //               cell: (item) =>
            //                 (
            //                   <Badge color="blue">
            //                     KD {parseFloat(item.sum_insured).toFixed(3)}
            //                   </Badge>
            //                 ) || "-",
            //             },
            //           ]}
            //           enableKeyboardNavigation
            //           items={isRisksData}
            //           loadingText="Loading risks"
            //           loading={!isRisksDataLoaded}
            //           sortingDisabled
            //           empty={
            //             <Box
            //               margin={{ vertical: "xs" }}
            //               textAlign="center"
            //               color="inherit"
            //             >
            //               <SpaceBetween size="m">
            //                 <b>No risks</b>
            //               </SpaceBetween>
            //             </Box>
            //           }
            //         />
            //       ),
            //     },
            //   ]);

            //   setTabsList((p) => [
            //     ...p,
            //     {
            //       label: "Schedule",
            //       id: "schedule",
            //       content: (
            //         <Box textAlign="center">
            //           <SpaceBetween size="m">
            //             <div
            //               style={{
            //                 border: "1px solid rgba(0, 0, 0, 0.3)",
            //                 height: "750px",
            //               }}
            //             >
            //               <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            //                 <Viewer
            //                   fileUrl={`${serverEndpoint.replace(
            //                     ":5000",
            //                     ":5002"
            //                   )}/api/qr/get_schedule?pol_id=${searchParams.get(
            //                     "data"
            //                   )}`}
            //                 />
            //               </Worker>
            //             </div>
            //           </SpaceBetween>
            //         </Box>
            //       ),
            //     },
            //   ]);
            // }
          }
        },
        (error) => {
          try {
            setIsPolicyDataLoaded(true);
            setPolicyData(error.response.data);
          } catch {
            setPolicyData({
              operation: false,
              data: null,
              message: "error_unreachable",
            });
          }
        }
      );
  }, []);

  const [activeTabId, setActiveTabId] = React.useState("conditions");

  return (
    <ContentLayout
      defaultPadding
      headerVariant="high-contrast"
      // headerBackgroundStyle="linear-gradient(135deg, rgb(145, 134, 215) 2%, rgb(149, 85, 182) 10%, rgb(131, 57, 157) 35%, rgb(71, 17, 118) 65%)"
      header={
        <Header
          variant="h3"
          actions={
            <SpaceBetween size="m">
              <Box float="right">
                <Button
                  onClick={toggleLang} variant="normal">{t("Switch Lanuage")}</Button>
              </Box>
              {/* <Button href="https://ilaftakaful.com/" external variant="primary">{t("Official Website")}</Button> */}
            </SpaceBetween>
          }
        >
          <img
            alt="ILAF Takaful Insurance Company"
            width={150}
            src="/images/ilaf_transparent_logo.png"
          />
        </Header>
      }
    >
      <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
        <Grid gridDefinition={[{ colspan: { default: 12, xxs: 12 } }]}>
          <Container
            header={<Header variant="h3">{t("Policy Details")}</Header>}
          >
            {/* {JSON.stringify(policyData)} */}

            {isPolicyDataLoaded ? (
              policyData.operation === false ? (
                <Flashbar
                  items={[
                    {
                      type: "error",
                      dismissible: false,
                      content: <strong>{t(policyData.message)}</strong>,
                      id: "message_0",
                    },
                  ]}
                />
              ) : null
            ) : null}
            {isPolicyDataLoaded ? (
              policyData.operation === false ? null : (
                <SpaceBetween size="l">
                  <KeyValuePairs columns={3} items={policyDataValues} />
                  {/* {!policyDataValues[0].value.props.children.props.children.startsWith(
                    "5"
                  ) ? (
                    <TextContent>
                      <small style={{ color: "red" }}>
                        <strong>
                          * For all terms and conditions, deductions, etc.,
                          please refer policy schedule.{" "}
                        </strong>
                      </small>
                    </TextContent>
                  ) : null} */}
                  <Tabs
                    onChange={({ detail }) => {
                      setActiveTabId(detail.activeTabId);
                      if (
                        detail.activeTabId === "risks" &&
                        !isRisksDataLoaded
                      ) {
                        getRisks();
                      }
                      if (
                        detail.activeTabId === "conditions" &&
                        !isConditionsLoaded
                      ) {
                        getConditions();
                      }
                      if (
                        detail.activeTabId === "premium_endorsement" &&
                        !isPremiumEndorsementLoaded
                      ) {
                        getPremiumEndorsement();
                      }
                      // if(detail.activeTabId === 'schedule'){

                      // }
                    }}
                    activeTabId={activeTabId}
                    tabs={
                      policyDataValues[0].value.props.children.props.children.startsWith(
                        "5"
                      )
                        ? [
                            {
                              label: t("Conditions"),
                              id: "conditions",
                              content: (
                                <Table
                                  columnDefinitions={[
                                    {
                                      id: "sr_no",
                                      header: "Serial No.",
                                      cell: (item) => item.sr_no || "-",
                                      sortingField: "sr_no",
                                    },
                                    {
                                      id: "description",
                                      header: "Description",
                                      cell: (item) => item.description || "-",
                                    },
                                  ]}
                                  enableKeyboardNavigation
                                  items={conditionsData}
                                  loadingText="Loading conditions"
                                  loading={!isConditionsLoaded}
                                  sortingDisabled
                                  empty={
                                    <Box
                                      margin={{ vertical: "xs" }}
                                      textAlign="center"
                                      color="inherit"
                                    >
                                      <SpaceBetween size="m">
                                        <b>No conditions</b>
                                      </SpaceBetween>
                                    </Box>
                                  }
                                />
                              ),
                            },
                            {
                              label: t("Risks"),
                              id: "risks",
                              content: (
                                <Table
                                  columnDefinitions={[
                                    {
                                      id: "id",
                                      header: "ID",
                                      cell: (item) => item.id || "-",
                                      sortingField: "id",
                                      isRowHeader: true,
                                    },
                                    {
                                      id: "added_on",
                                      header: "Added On",
                                      cell: (item) =>
                                        moment(
                                          new Date(item.added_on)
                                        ).isValid() ? (
                                          <Badge>
                                            {moment(
                                              new Date(item.added_on)
                                            ).format("DD-MMM-YYYY")}
                                          </Badge>
                                        ) : (
                                          "-" || "-"
                                        ),
                                      sortingField: "added_on",
                                    },
                                    {
                                      id: "deleted_on",
                                      header: "Deleted On",
                                      cell: (item) =>
                                        moment(
                                          new Date(item.deleted_on)
                                        ).isValid() ? (
                                          <Badge color="red">
                                            {moment(
                                              new Date(item.deleted_on)
                                            ).format("DD-MMM-YYYY")}
                                          </Badge>
                                        ) : (
                                          "-" || "-"
                                        ),
                                      sortingField: "deleted_on",
                                    },
                                    {
                                      id: "effective_start",
                                      header: "Effective Start",
                                      cell: (item) =>
                                        moment(
                                          new Date(item.effective_start)
                                        ).isValid() ? (
                                          <Badge color="green">
                                            {moment(
                                              new Date(item.effective_start)
                                            ).format("DD-MMM-YYYY")}
                                          </Badge>
                                        ) : (
                                          "-" || "-"
                                        ),
                                      sortingField: "effective_start",
                                    },
                                    {
                                      id: "effective_end",
                                      header: "Effective End",
                                      cell: (item) =>
                                        moment(
                                          new Date(item.effective_end)
                                        ).isValid() ? (
                                          <Badge
                                            color={
                                              moment(
                                                new Date(item.deleted_on)
                                              ).isValid()
                                                ? "red"
                                                : "green"
                                            }
                                          >
                                            {moment(
                                              new Date(item.effective_end)
                                            ).format("DD-MMM-YYYY")}
                                          </Badge>
                                        ) : (
                                          "-" || "-"
                                        ),
                                      sortingField: "effective_end",
                                    },
                                    {
                                      id: "registration_no",
                                      header: "Registration No.",
                                      cell: (item) =>
                                        item.registration_no || "-",
                                    },
                                    {
                                      id: "chassis_no",
                                      header: policyDataValues[0].value.props.children.props.children.startsWith(
                        "5"
                      ) ? "Chassis No." : "Assured Name",
                                      cell: (item) => item.chassis_no || "-",
                                    },
                                    {
                                      id: "vehicle_make",
                                      header: "Make",
                                      cell: (item) => item.vehicle_make || "-",
                                    },
                                    {
                                      id: "sum_insured",
                                      header: "Sum Insured",
                                      cell: (item) =>
                                        (
                                          <Badge color="blue">
                                            KD{" "}
                                            {parseFloat(
                                              item.sum_insured
                                            ).toFixed(3)}
                                          </Badge>
                                        ) || "-",
                                    },
                                  ]}
                                  enableKeyboardNavigation
                                  items={isRisksData}
                                  loadingText="Loading risks"
                                  loading={!isRisksDataLoaded}
                                  sortingDisabled
                                  empty={
                                    <Box
                                      margin={{ vertical: "xs" }}
                                      textAlign="center"
                                      color="inherit"
                                    >
                                      <SpaceBetween size="m">
                                        <b>No risks</b>
                                      </SpaceBetween>
                                    </Box>
                                  }
                                />
                              ),
                            },
                            {
                              label: t("Schedule"),
                              id: "schedule",
                              content: (
                                <Box textAlign="center">
                                  <SpaceBetween size="m">
                                    <div
                                      style={{
                                        border: "1px solid rgba(0, 0, 0, 0.3)",
                                        height: "750px",
                                      }}
                                    >
                                      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                        <Viewer
                                          renderError={() => (
                                            <Box
                                              margin="xxxl"
                                              textAlign="center"
                                            >
                                              <Badge color="red">
                                                Missing Schedule
                                              </Badge>
                                            </Box>
                                          )}
                                          fileUrl={
                                            policyData?.data?.policy_number?.startsWith(
                                              "5001/"
                                            )
                                              ? `${serverEndpoint}/api/qr/get_5001_schedule?pol_id=${
                                                  searchParams
                                                    .get("data")
                                                    .split("_")[0]
                                                }`
                                              : `${serverEndpoint}/api/qr/get_m_schedule?pol_id=${
                                                  searchParams
                                                    .get("data")
                                                    .split("_")[0]
                                                }&pol_end_idx_no=${
                                                  searchParams
                                                    .get("data")
                                                    .split("_")[1]
                                                }`
                                          }
                                        />
                                      </Worker>
                                    </div>
                                  </SpaceBetween>
                                </Box>
                              ),
                            },
                            {
                              label: t("Endorsement"),
                              id: "premium_endorsement",
                              content: (
                                <Table
                                  columnDefinitions={[
                                    {
                                      id: "POLH_END_NO_IDX",
                                      header: "S.No",
                                      cell: (item) =>
                                        item.POLH_END_NO_IDX ?? "-",
                                    },
                                    {
                                      id: "POLH_APPR_DT",
                                      header: "Approve Date",
                                      cell: (item) => item.POLH_APPR_DT ?? "-",
                                    },
                                    {
                                      id: "ENDT_DESC",
                                      header: "Description",
                                      cell: (item) => item.ENDT_DESC ?? "-",
                                    },
                                    {
                                      id: "POLH_END_NO",
                                      header: "Endorsement No",
                                      cell: (item) => item.POLH_END_NO ?? "-",
                                    },
                                    {
                                      id: "PREMIUM",
                                      header: "Premium",
                                      cell: (item) => item.PREMIUM ?? "-",
                                    },
                                    {
                                      id: "CTRL_FEES",
                                      header: "Control Fees",
                                      cell: (item) => item.CTRL_FEES ?? "-",
                                    },
                                    {
                                      id: "BENE_FEES",
                                      header: "Beneficiary Fees",
                                      cell: (item) => item.BENE_FEES ?? "-",
                                    },
                                    {
                                      id: "CONTRIBUTOR_FEE",
                                      header: "Contribution Fee",
                                      cell: (item) =>
                                        item.CONTRIBUTOR_FEE ?? "-",
                                    },
                                    {
                                      id: "OTHER_FEE",
                                      header: "Other Fees",
                                      cell: (item) => item.OTHER_FEE ?? "-",
                                    },
                                    {
                                      id: "TOTAL_PREMIUM",
                                      header: "Total Premium",
                                      cell: (item) =>
                                        (
                                          (parseFloat(item.PREMIUM) || 0) +
                                          (parseFloat(item.CTRL_FEES) || 0) +
                                          (parseFloat(item.BENE_FEES) || 0) +
                                          (parseFloat(item.CONTRIBUTOR_FEE) ||
                                            0) +
                                          (parseFloat(item.OTHER_FEE) || 0)
                                        ).toFixed(3),
                                    },
                                  ]}
                                  enableKeyboardNavigation
                                  items={premiumEndorsementData}
                                  loadingText="Loading premium and endorsement"
                                  loading={!isPremiumEndorsementLoaded}
                                  sortingDisabled
                                  empty={
                                    <Box
                                      margin={{ vertical: "xs" }}
                                      textAlign="center"
                                      color="inherit"
                                    >
                                      <SpaceBetween size="m">
                                        <b>
                                          {t(
                                            "No premium and endorsement data"
                                          )}
                                        </b>
                                      </SpaceBetween>
                                    </Box>
                                  }
                                />
                              ),
                            },
                          ]
                        : [
                            {
                              label: "Risk Information",
                              id: "risks",
                              content: (
                                <Table
                                  columnDefinitions={[
                                    {
                                      id: "id",
                                      header: "ID",
                                      cell: (item) => item.id || "-",
                                      sortingField: "id",
                                      isRowHeader: true,
                                    },
                                    {
                                      id: "added_on",
                                      header: "Added On",
                                      cell: (item) =>
                                        moment(
                                          new Date(item.added_on)
                                        ).isValid() ? (
                                          <Badge>
                                            {moment(
                                              new Date(item.added_on)
                                            ).format("DD-MMM-YYYY")}
                                          </Badge>
                                        ) : (
                                          "-" || "-"
                                        ),
                                      sortingField: "added_on",
                                    },
                                    {
                                      id: "deleted_on",
                                      header: "Deleted On",
                                      cell: (item) =>
                                        moment(
                                          new Date(item.deleted_on)
                                        ).isValid() ? (
                                          <Badge color="red">
                                            {moment(
                                              new Date(item.deleted_on)
                                            ).format("DD-MMM-YYYY")}
                                          </Badge>
                                        ) : (
                                          "-" || "-"
                                        ),
                                      sortingField: "deleted_on",
                                    },
                                    {
                                      id: "effective_start",
                                      header: "Effective Start",
                                      cell: (item) =>
                                        moment(
                                          new Date(item.effective_start)
                                        ).isValid() ? (
                                          <Badge color="green">
                                            {moment(
                                              new Date(item.effective_start)
                                            ).format("DD-MMM-YYYY")}
                                          </Badge>
                                        ) : (
                                          "-" || "-"
                                        ),
                                      sortingField: "effective_start",
                                    },
                                    {
                                      id: "effective_end",
                                      header: "Effective End",
                                      cell: (item) =>
                                        moment(
                                          new Date(item.effective_end)
                                        ).isValid() ? (
                                          <Badge
                                            color={
                                              moment(
                                                new Date(item.deleted_on)
                                              ).isValid()
                                                ? "red"
                                                : "green"
                                            }
                                          >
                                            {moment(
                                              new Date(item.effective_end)
                                            ).format("DD-MMM-YYYY")}
                                          </Badge>
                                        ) : (
                                          "-" || "-"
                                        ),
                                      sortingField: "effective_end",
                                    },
                                    {
                                      id: "registration_no",
                                      header: "Registration No.",
                                      cell: (item) =>
                                        item.registration_no || "-",
                                    },
                                    {
                                      id: "chassis_no",
                                      header: "Chassis No.",
                                      cell: (item) => item.chassis_no || "-",
                                    },
                                    {
                                      id: "vehicle_make",
                                      header: "Make",
                                      cell: (item) => item.vehicle_make || "-",
                                    },
                                    {
                                      id: "sum_insured",
                                      header: "Sum Insured",
                                      cell: (item) =>
                                        (
                                          <Badge color="blue">
                                            KD{" "}
                                            {parseFloat(
                                              item.sum_insured
                                            ).toFixed(3)}
                                          </Badge>
                                        ) || "-",
                                    },
                                    {
                                      id: "premium",
                                      header: "Premium",
                                      cell: (item) =>
                                        (
                                          <Badge color="blue">
                                            KD{" "}
                                            {parseFloat(item.premium).toFixed(
                                              3
                                            )}
                                          </Badge>
                                        ) || "-",
                                    },
                                  ]}
                                  enableKeyboardNavigation
                                  items={isRisksData}
                                  loadingText="Loading risk information"
                                  loading={!isRisksDataLoaded}
                                  sortingDisabled
                                  empty={
                                    <Box
                                      margin={{ vertical: "xs" }}
                                      textAlign="center"
                                      color="inherit"
                                    >
                                      <SpaceBetween size="m">
                                        <b>No risk information</b>
                                      </SpaceBetween>
                                    </Box>
                                  }
                                />
                              ),
                            },
                            {
                              label: t("Schedule"),
                              id: "schedule",
                              content: (
                                <Box textAlign="center">
                                  <SpaceBetween size="m">
                                    <div
                                      style={{
                                        border: "1px solid rgba(0, 0, 0, 0.3)",
                                        height: "750px",
                                      }}
                                    >
                                      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                        <Viewer
                                          renderError={() => (
                                            <Box
                                              margin="xxxl"
                                              textAlign="center"
                                            >
                                              <Badge color="red">
                                                Missing Schedule
                                              </Badge>
                                            </Box>
                                          )}
                                          fileUrl={`${serverEndpoint}/api/qr/get_m_schedule?pol_id=${
                                            searchParams
                                              .get("data")
                                              .split("_")[0]
                                          }&pol_end_idx_no=${
                                            searchParams
                                              .get("data")
                                              .split("_")[1]
                                          }`}
                                        />
                                      </Worker>
                                    </div>
                                  </SpaceBetween>
                                </Box>
                              ),
                            },
                            {
                              label: t("Endorsement"),
                              id: "premium_endorsement",
                              content: (
                                <Table
                                  columnDefinitions={[
                                    {
                                      id: "POLH_END_NO_IDX",
                                      header: "S.No",
                                      cell: (item) =>
                                        item.POLH_END_NO_IDX ?? "-",
                                    },
                                    {
                                      id: "POLH_APPR_DT",
                                      header: "Approve Date",
                                      cell: (item) => item.POLH_APPR_DT ?? "-",
                                    },
                                    {
                                      id: "ENDT_DESC",
                                      header: "Description",
                                      cell: (item) => item.ENDT_DESC ?? "-",
                                    },
                                    {
                                      id: "POLH_END_NO",
                                      header: "Endorsement No",
                                      cell: (item) => item.POLH_END_NO ?? "-",
                                    },
                                    {
                                      id: "PREMIUM",
                                      header: "Premium",
                                      cell: (item) => item.PREMIUM ?? "-",
                                    },
                                    {
                                      id: "CTRL_FEES",
                                      header: "Control Fees",
                                      cell: (item) => item.CTRL_FEES ?? "-",
                                    },
                                    {
                                      id: "BENE_FEES",
                                      header: "Beneficiary Fees",
                                      cell: (item) => item.BENE_FEES ?? "-",
                                    },
                                    {
                                      id: "CONTRIBUTOR_FEE",
                                      header: "Contribution Fee",
                                      cell: (item) =>
                                        item.CONTRIBUTOR_FEE ?? "-",
                                    },
                                    {
                                      id: "OTHER_FEE",
                                      header: "Other Fees",
                                      cell: (item) => item.OTHER_FEE ?? "-",
                                    },
                                    {
                                      id: "TOTAL_PREMIUM",
                                      header: "Total Premium",
                                      cell: (item) =>
                                        (
                                          (parseFloat(item.PREMIUM) || 0) +
                                          (parseFloat(item.CTRL_FEES) || 0) +
                                          (parseFloat(item.BENE_FEES) || 0) +
                                          (parseFloat(item.CONTRIBUTOR_FEE) ||
                                            0) +
                                          (parseFloat(item.OTHER_FEE) || 0)
                                        ).toFixed(3),
                                    },
                                  ]}
                                  enableKeyboardNavigation
                                  items={premiumEndorsementData}
                                  loadingText="Loading premium and endorsement"
                                  loading={!isPremiumEndorsementLoaded}
                                  sortingDisabled
                                  empty={
                                    <Box
                                      margin={{ vertical: "xs" }}
                                      textAlign="center"
                                      color="inherit"
                                    >
                                      <SpaceBetween size="m">
                                        <b>
                                          {t(
                                            "No premium and endorsement data"
                                          )}
                                        </b>
                                      </SpaceBetween>
                                    </Box>
                                  }
                                />
                              ),
                            },
                          ]
                    }
                  />
                </SpaceBetween>
              )
            ) : (
              <LiveRegion>
                <SpaceBetween size="s">
                  <Box
                    margin={{ bottom: "xs", left: "l" }}
                    color="text-body-secondary"
                  >
                    <TextContent>
                      <p>
                        <strong>{t("Getting Policy Details")}</strong>
                      </p>
                    </TextContent>
                  </Box>
                  <LoadingBar variant="gen-ai" />
                </SpaceBetween>
                <KeyValuePairs columns={3} items={[]} />
              </LiveRegion>
            )}
          </Container>
          <div></div>
        </Grid>
      </div>
    </ContentLayout>
  );
}

export default ManualLandingPage;
